import { AbsoluteCenter, Flex, Spinner, Text } from '@chakra-ui/react';
import type React from 'react';

interface LoaderProps extends React.ComponentProps<typeof AbsoluteCenter> {
  logoSrc?: string; // Path to the logo image
  spinnerColor?: string; // Spinner color (default: teal)
  loadingText?: string; // Optional loading message
}

const Loader: React.FC<LoaderProps> = ({
  spinnerColor = 'primary.500',
  loadingText = 'Loading, please wait...',
  ...props
}) => {
  return (
    <AbsoluteCenter {...props}>
      <Flex align="center" justify="center" direction="column" animation="pulse">
        {/* Spinner */}
        <Spinner color={spinnerColor} size="xl" mb={4} />

        {/* Loading Text */}
        {loadingText && (
          <Text fontSize="lg" textAlign="center">
            {loadingText}
          </Text>
        )}
      </Flex>
    </AbsoluteCenter>
  );
};

export default Loader;
